import { translate } from "app/filters/i18nFilter";
import type { IntentCountryScopeDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import { REST_OF_WORLD_COUNTRY_ID } from "app/pages/sales-intelligence/sub-modules/intent/constants/countries";

import CountryListItem from "./CountryListItem";
import { StyledEmptyTooltip } from "./styles";

type Props = {
    countries: readonly IntentCountryScopeDto[];
};

const IntentSignalsEventsTooltipContent = ({ countries }: Props) => {
    const filteredCountries = countries.filter((country) => country.countryCode !== REST_OF_WORLD_COUNTRY_ID);

    return filteredCountries.length === 0 ? (
        <StyledEmptyTooltip>{translate("si.signals.company-overview.tooltip.content.empty")}</StyledEmptyTooltip>
    ) : (
        filteredCountries.map((country) => (
            <CountryListItem
                key={country.countryCode}
                item={country}
            />
        ))
    );
};

export default IntentSignalsEventsTooltipContent;
